import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import EventCard from '../EventCard';
import EventsFilter from '../Filter';
import { useLocation } from 'react-router-dom';

const List = ({ events, eventsPath, featuredId, remainingEvents = [], rotatedFeaturedItems = [] }) => {
  const location = useLocation();
  const isPrivateEvent = location.pathname.startsWith('/members');

  return (
    <div className="lg:container mx-auto px-6 sm:mb-10 max-w-full">
      <EventsFilter />
      {!isEmpty(remainingEvents) || !isEmpty(rotatedFeaturedItems) ? (
        <div className={`sm:grid gap-10 ${isPrivateEvent ? 'sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3' : 'sm:grid-cols-2 lg:grid-cols-3'}`}>
          {rotatedFeaturedItems?.map((item) => (
            <React.Fragment key={item.id}>
              <EventCard events={item} eventsPath={eventsPath} />
            </React.Fragment>
          ))}
          {remainingEvents.map((item) => (
            <React.Fragment key={item.id}>
              <EventCard events={item} eventsPath={eventsPath} />
            </React.Fragment>
          ))}
        </div>
      ) : (
        <div className="p-10 text-center my-24">No events found</div>
      )}
    </div>
  );
};

List.propTypes = {
  events: PropTypes.array.isRequired,
  eventsPath: PropTypes.string,
  featuredId: PropTypes.string.isRequired,
  remainingEvents: PropTypes.array,
  rotatedFeaturedItems: PropTypes.array,
};

List.defaultProps = {
  eventsPath: '/events',
};

export default List;
